import React from 'react';
import { Grid, Typography, Divider, Paper } from '@mui/material';
import FormattedField, { formatter } from './CaseUtils';
import InfoGrid from '../../Shared/InfoGrid';
import BMIProfile from './BMIProfile';
import BasicMap from './BasicMap';

// Styles
import BasicCaseInfoStyles from '../../../assets/jss/Components/Cases/BasicCaseInfoStyles';

export const firstRowInfo = ['dateOfBirth', 'dateOfDeath'];
export const infoToShow = [
    'age',
    'sex',
    'genderIdentity',
    'ethnicity',
    'height',
    'weight',
    'bmi',
];

// @ts-ignore
export const BasicInfo = ({ info, ...props }) => {
    const { classes } = BasicCaseInfoStyles();

    const infoReducer = (
        accum: { [x: string]: any },
        value: string | number
    ) => {
        // @ts-ignore
        if (formatter[value]) {
            accum[value] = {
                empty:
                    info[value] === null ||
                    (info[value] && info[value].length === 0) ||
                    info[value] === undefined,
                render: (
                    <FormattedField
                        // @ts-ignore
                        value={info[value]}
                        field={value}
                        obj={info}
                    />
                ),
            };
        } else if (typeof info[value] !== 'object') {
            accum[value] = info[value];
            if (value === 'age' && info[value]) {
                accum[value] = Math.floor(info[value]);
            }
        }
        return accum;
    };

    return (
        <Paper className={classes.container} elevation={0}>
            <Grid
                container
                spacing={2}
                justifyContent="center"
                style={{ padding: 10 }}
            >
                {/* HEADER */}
                <Grid
                    item
                    container
                    justifyContent="center"
                    alignItems="center"
                    spacing={1}
                >
                    <Grid item>
                        <Typography variant="h6">
                            {`${info.firstName} ${info.middleName || ''} ${
                                info.lastName
                            }`}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                </Grid>
                {/*LEFT */}
                <Grid item xs={12} style={{ padding: 10 }}>
                    <InfoGrid
                        info={firstRowInfo.reduce(infoReducer, {})}
                        caseInfo={undefined}
                    />
                </Grid>
                <Grid item xs={12}>
                    <InfoGrid
                        info={infoToShow.reduce(infoReducer, {})}
                        caseInfo={undefined}
                    />
                </Grid>
                {info.residence && info.residence.geolocated && (
                    <Grid item xs={12} style={{ height: 200 }}>
                        <BasicMap
                            latitude={info.residence.latitude}
                            longitude={info.residence.longitude}
                            title={''}
                            location="Home Address"
                            classes={undefined}
                        />
                    </Grid>
                )}
                <Grid item container justifyContent="space-around" spacing={1}>
                    <Grid item xs={12}>
                        <Grid
                            item
                            container
                            direction="column"
                            style={
                                !info.residence ||
                                (!info.residence.parsedAddress &&
                                    !info.residence.originalAddress)
                                    ? { opacity: 0.3 }
                                    : {}
                            }
                        >
                            <Grid item>
                                <Typography
                                    variant="caption"
                                    color={'primary'}
                                    style={{
                                        fontSize: '0.7em',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    Home Address
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography>
                                    {(info.residence &&
                                        (info.residence.parsedAddress ||
                                            info.residence.originalAddress)) ||
                                        'N/A'}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {/* MIDDLE */}
                <Grid item xs={12}>
                    <BMIProfile
                        sex={info.sex === 'M' ? 'male' : 'female'}
                        status={info.bmiStatus}
                        showBMI={info.validBMI}
                        height={info.height / 39.37}
                        // weight={/*info.weight / 2.205*/ 1.5}
                        weight={info.bmi}
                        classes={undefined}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
};

export default BasicInfo;
